export default Object.freeze({
  SELECT_TEMPLATE: 'SMS/e-mail을 발송할 회원을 선택합니다.',
  TITLE: '회원등급/그룹 선택',
  RECIPIENT_GRADE: '회원 등급',
  RECIPIENT_GROUP: '회원 그룹',
  TH_GRADE: '대상 회원 등급',
  TH_GROUP: '대상 회원 그룹',
  PER: '명',
  ALL_GRADE: '전체',
  APPLY_BTN: '저장',
  CANCEL_BTN: '닫기',
});
